import { GetOptions, StockCheck } from "@/core";
import { repositoryHost } from "@/repositories";
import { serviceHost } from "@/services";
import { useInfiniteQuery, useQuery } from "@tanstack/react-query";
import { getNextPageParam } from "../utils/page-params";

const databaseService = serviceHost.getDatabaseService();
const stockCheckRepository = repositoryHost.getStockCheckRepository(databaseService);

export const useStockChecks = (options: GetOptions<StockCheck>) => {
  return useInfiniteQuery({
    queryKey: ["stock-checks", "get", JSON.stringify(options)],
    queryFn: ({ pageParam }) =>
      stockCheckRepository.getAll({
        ...options,
        pagination: {
          ...options.pagination,
          cursor: pageParam,
        },
      }),
    initialPageParam: "",
    getNextPageParam: getNextPageParam(options),
  });
};

export const useStockChecksByInventoryId = (inventoryId: string) => {
  return useQuery({
    queryKey: ["stock-checks", "by-inventory", inventoryId],
    enabled: inventoryId.length > 0,
    queryFn: async () =>
      stockCheckRepository.getAll({
        queryConstraints: [
          {
            field: "inventoryId",
            operator: "==",
            value: inventoryId,
          },
        ],
        orderBy: {
          field: "checkedAt",
          direction: "desc",
        },
        pagination: {
          limit: 200,
        },
      }),
  });
};
